import { Box, Button, Group } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { CrmField } from "~/components/input-fields/crm-field";
import { useCrmTableView } from "~/hooks/use-crm-table-view";

export const Route = createFileRoute("/_authenticated/test")({
  component: RouteComponent,
});

function RouteComponent() {
  const view = useCrmTableView("crm.customer", { id: 2077, readOnly: "You can edit it in the customer view" });

  return (
    <Box p="md">
      <CrmField {...view.getFieldProps("id")} />
      <CrmField {...view.getFieldProps("name")} />
      <CrmField {...view.getFieldProps("email")} />
      <CrmField {...view.getFieldProps("phone")} />
      <Group my="lg">
        <Button onClick={view.reset} disabled={!view.isDirty || view.isUpdatePending}>Reset</Button>
        <Button onClick={view.saveChanges} disabled={!view.isDirty} loading={view.isUpdatePending}>Save</Button>
      </Group>
      <pre>{JSON.stringify(view.dirtyFields, null, 2)}</pre>
    </Box>
  );
}
